import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, CheckCircle2Icon, GiftIcon } from 'lucide-react';
type Volume = {
  title: string;
  items: string[];
  border: string;
};
type Bonus = {
  number: string;
  title: string;
  details: string[];
  value: string;
};
const volumes: Volume[] = [{
  title: 'Volumen 1 — El Código del Lodo',
  items: ['Entendés por qué el omeprazol agrava la causa real', 'Descubrís qué está pasando realmente en tu intestino', 'Identificás tu nivel de lodo sin estudios caros', 'Conectás inflamación, cansancio y digestión en un mapa', 'Arrancás con claridad total desde el Día 1'],
  border: 'border-blue-400/30'
}, {
  title: 'Volumen 2 — Fase de Barrido',
  items: ['Descubrís qué alimentos actúan como escoba biológica', 'Sabés exactamente qué comer y qué evitar', 'Usás ingredientes de cualquier super argentino', 'Reducís la inflamación sin pasar hambre', 'Empezás hoy, sin preparación previa'],
  border: 'border-green-400/30'
}, {
  title: 'Volumen 3 — Desintegración del Vientre',
  items: ['Entendés por qué los tratamientos anteriores fallaron', 'Aplicás un cronograma de 15 días con hierbas accesibles', 'Eliminás la fermentación que genera gases y ardor crónico', 'Notás cambios en tu energía desde la primera semana', 'Avanzás fase por fase sin confusión'],
  border: 'border-amber-400/30'
}, {
  title: 'Volumen 4 — Siembra y Blindaje',
  items: ['Restaurás tu flora con los alimentos en el orden correcto', 'Sellás la barrera intestinal para que el ardor no vuelva', 'Reactivás tu producción natural de ácido gástrico', 'Recuperás la energía que perdiste con años de medicación', 'Salís del ciclo de dependencia con un plan claro'],
  border: 'border-red-400/30'
}, {
  title: 'Volumen 5 — Ligereza Total',
  items: ['Volvés a disfrutar el asado y el mate sin pastillas', 'Tenés un plan de mantenimiento para no empezar de cero', 'Detectás señales de recaída antes de que se conviertan en crisis', 'Usás recetas adaptadas a la cocina argentina', 'Vivís con un intestino fuerte sin depender de nada externo'],
  border: 'border-yellow-400/30'
}];
const bonuses: Bonus[] = [{
  number: '01',
  title: 'Mapa de Disparadores Digestivos',
  details: ['Identificás en 7 días exactamente qué alimento o hábito te está generando el lodo', 'Dejás de adivinar y empezás a actuar con información concreta sobre tu cuerpo', 'Acelerás los resultados del protocolo desde la primera semana'],
  value: '$12.000'
}, {
  number: '02',
  title: 'Lista de Compras Anti-Lodo',
  details: ['Entrás al super con una guía clara de qué comprar para empezar a sanar', 'Ahorrás tiempo y plata sin comprar lo que no sirve o te inflama', 'Encontrás todo en cualquier supermercado argentino'],
  value: '$10.000'
}, {
  number: '03',
  title: 'Kit Noches Sin Ardor',
  details: ['Dormís sin despertarte con fuego en el pecho ni carraspera nocturna', 'Aplicás una rutina simple antes de acostarte que calma el sistema digestivo', 'Recuperás el descanso profundo que el ardor te venía robando'],
  value: '$9.000'
}, {
  number: '04',
  title: 'Plato Barrido Liviano',
  details: ['Armás platos simples, saciantes y antiinflamatorios sin contar calorías', 'Comés rico y variado sin una dieta aburrida o restrictiva', 'Combinás alimentos de forma inteligente para que tu intestino no fermente'],
  value: '$11.000'
}, {
  number: '05',
  title: 'Tracker de Seguimiento y Consulta Médica',
  details: ['Llegás a tu próxima consulta con registros claros y preguntas inteligentes', 'Documentás tu progreso día a día para no perder ninguna señal importante', 'Tomás el control de tu salud digestiva con datos reales en la mano'],
  value: '$10.000'
}];
export function ProductOffer() {
  return <>
      <section className="bg-brand-dark px-4 py-16 sm:py-24" data-id="element-124">
        <div className="mx-auto max-w-5xl" data-id="element-125">
          <header className="text-center" data-id="element-126">
            <h2 className="font-display text-3xl font-bold text-brand-gold sm:text-5xl" data-id="element-127">
              PROTOCOLO BARRIDO INTESTINAL™
            </h2>
            <p className="mx-auto mt-4 max-w-4xl text-lg font-medium text-white sm:text-xl" data-id="element-128">
              Tu hoja de ruta completa en 5 volúmenes para desintegrar el lodo
              biológico y volver a comer sin miedo.
            </p>
            <h3 className="mt-12 font-display text-2xl font-bold" data-id="element-129">
              5 VOLÚMENES COMPLETOS
            </h3>
          </header>

          <div className="mt-7 space-y-5" data-id="element-130">
            {volumes.map((volume, index) => <motion.article key={volume.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.06
          }} className={`flex gap-5 rounded-2xl border ${volume.border} bg-brand-ink p-5 sm:p-7`} data-id="element-131">
                <BookOpenIcon className="mt-1 h-7 w-7 shrink-0 text-brand-gold" aria-hidden="true" data-id="element-132" />
                <div data-id="element-133">
                  <h4 className="font-display text-lg font-bold sm:text-xl" data-id="element-134">
                    {volume.title}
                  </h4>
                  <ul className="mt-4 space-y-2" data-id="element-135">
                    {volume.items.map(item => <li key={item} className="flex gap-2 text-sm leading-relaxed text-slate-300 sm:text-base" data-id="element-136">
                        <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0 text-brand-light" aria-hidden="true" data-id="element-137" />
                        {item}
                      </li>)}
                  </ul>
                </div>
              </motion.article>)}
          </div>

          <div className="mt-8 rounded-2xl border border-brand-green/30 bg-brand-green/10 p-6 sm:p-8" data-id="element-138">
            <h4 className="text-center font-display text-xl font-bold" data-id="element-139">
              El Protocolo incluye:
            </h4>
            <div className="mt-6 grid gap-3 sm:grid-cols-2" data-id="element-140">
              {['Plan diario listo para arrancar hoy', 'Cronograma de barrido intestinal de 30 días', 'Guía práctica de alimentos y combinaciones', 'Checklist imprimible por etapa'].map(item => <p key={item} className="flex gap-2 text-slate-200" data-id="element-141">
                  <CheckCircle2Icon className="h-5 w-5 shrink-0 text-brand-light" aria-hidden="true" data-id="element-142" />
                  {item}
                </p>)}
            </div>
          </div>
        </div>
      </section>

      <section className="bg-brand-ink px-4 py-16 sm:py-24" data-id="element-143">
        <div className="mx-auto max-w-5xl" data-id="element-144">
          <header className="text-center" data-id="element-145">
            <GiftIcon className="mx-auto h-10 w-10 text-brand-gold" aria-hidden="true" data-id="element-146" />
            <h2 className="mt-3 font-display text-3xl font-bold text-brand-gold sm:text-5xl" data-id="element-147">
              5 BONOS ESTRATÉGICOS
            </h2>
            <p className="mt-2 font-semibold tracking-[0.18em] text-white" data-id="element-148">
              SIEMPRE INCLUIDOS
            </p>
          </header>

          <div className="mt-10 space-y-4" data-id="element-149">
            {bonuses.map(bonus => <article key={bonus.number} className="flex flex-col gap-4 rounded-2xl border border-brand-gold/20 bg-brand-dark p-5 sm:flex-row sm:items-start sm:p-7" data-id="element-150">
                <span className="w-fit rounded-lg bg-brand-gold/10 px-3 py-2 font-bold text-brand-gold" data-id="element-151">
                  BONO {bonus.number}
                </span>
                <div className="flex-1" data-id="element-152">
                  <h3 className="font-bold" data-id="element-153">{bonus.title}</h3>
                  <ul className="mt-3 space-y-2" data-id="element-154">
                    {bonus.details.map(detail => <li key={detail} className="flex gap-2 text-sm leading-relaxed text-slate-300" data-id="element-155">
                        <CheckCircle2Icon className="mt-0.5 h-4 w-4 shrink-0 text-brand-gold" aria-hidden="true" data-id="element-156" />
                        {detail}
                      </li>)}
                  </ul>
                </div>
                <div className="flex shrink-0 items-center gap-3" data-id="element-157">
                  <span className="text-sm text-slate-500 line-through" data-id="element-158">
                    {bonus.value}
                  </span>
                  <span className="rounded-full bg-brand-light px-3 py-1 text-sm font-bold text-brand-ink" data-id="element-159">
                    GRATIS
                  </span>
                </div>
              </article>)}
          </div>

          <div className="mt-8 rounded-2xl border border-brand-gold/30 bg-brand-gold/10 p-6 text-center" data-id="element-160">
            <p className="text-xs font-bold tracking-[0.17em] text-brand-gold" data-id="element-161">
              VALOR TOTAL BONOS
            </p>
            <p className="mt-1 text-2xl font-bold text-slate-400 line-through" data-id="element-162">
              $52.000
            </p>
            <p className="mt-2 font-display text-xl font-bold text-brand-gold" data-id="element-163">
              GRATIS con tu Protocolo Barrido Intestinal™
            </p>
          </div>
        </div>
      </section>
    </>;
}